import React from 'react'
import styled from 'styled-components'
import SubTitle from 'components/SubTitle'

const Slot = ({ children, slot }) => {
  let slottedChild = null

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return

    if (child.props['data-slot'] === slot) {
      slottedChild = React.cloneElement(child)
    }
  })

  return slottedChild
}

const Section = ({
  style,
  className,
  id,
  title,
  subtitle,
  grey,
  children,
  noContainer,
}) => (
  <Wrapper
    style={style}
    className={`${className} question`}
    grey={grey}
    id={id}>
    <Container noContainer={noContainer}>
      {title && <Title>{title}</Title>}
      {subtitle && (
        <SubTitle text={subtitle}>
          <Slot slot='tip'>{children}</Slot>
        </SubTitle>
      )}
      {React.Children.map(children, (child, i) => {
        if (React.isValidElement(child) && child.props['data-slot']) return
        return child
      })}
    </Container>
  </Wrapper>
)

export default Section

const Container = styled.div`
  width: 100%;
  ${({ noContainer }) =>
    !noContainer &&
    `
    max-width: 1200px;
    margin: 0 auto;
  `}
`

const Wrapper = styled.div`
  width: 100%;
  padding: ${({ compact }) => (compact ? '40px 0' : '80px 0')};
  text-align: center;
  display: flex;
  align-items: center;

  &:nth-child(even) {
    background-color: #f9f9f9;
  }

  &.invalid {
    h3 {
      color: indianred;
    }
  }
`

const Title = styled.h2`
  font-size: 32px;
  font-weight: bold;
  line-height: 32px;
  color: #010101;
  text-transform: uppercase;
  text-align: center;
  margin: 0;
  margin-bottom: 8px;

  @media screen and (max-width: 768px) {
    font-size: 22px;
    line-height: 22px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Section/index.js